import { Action } from '@ngrx/store';
import { PaymentTerm } from '@cemex-core/cmx-api';
import { PaymentTermsResponse } from '@ordersnproducts/modules/order-builder/modules/rms-specification/models/payment-term.op.model';

export enum ActionTypes {
  ADD = '[RMS OLC UL Payment Terms] Add',
  ADD_FAILURE = '[RMS OLC UL Payment Terms] Add Failure',
  LOAD = '[RMS OLC UL Payment Terms] Load',
  LOAD_SUCCESS = '[RMS OLC UL Payment Terms] Load Success',
  LOAD_FAILURE = '[RMS OLC UL Payment Terms] Load Failure',
}

export class Add implements Action {
  readonly type: string = ActionTypes.ADD;
  constructor(public payload: PaymentTerm) {}
}

export class AddFailure implements Action {
  readonly type: string = ActionTypes.ADD_FAILURE;
  constructor(public payload?: any) {}
}

export class Load implements Action {
  readonly type: string = ActionTypes.LOAD;
  constructor(public payload?: any) {}
}

export class LoadSuccess implements Action {
  readonly type: string = ActionTypes.LOAD_SUCCESS;
  constructor(public payload: PaymentTermsResponse) {}
}

export class LoadFailure implements Action {
  readonly type: string = ActionTypes.LOAD_FAILURE;
  constructor(public payload?: any) {}
}

export type Actions = Add | AddFailure | Load | LoadSuccess | LoadFailure;
